// components/find-me-a-tenant/FindMeATenantButton.jsx

import React, { useState } from "react";
import { Button } from "@mui/material";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import BlanketAgreementDialog from "./Blanketagreementdialog";
import FindMeATenantFlow from "./findMeATenant/FindMeATenantFlow";

/**
 * FindMeATenantButton
 *
 * Drop this anywhere — ManageListings header or PropertyDetailView header.
 * Fully self-contained: handles the agreement gate, then opens the order
 * flow (property info -> payment -> order created) itself.
 *
 * Props:
 *   uid        {string}   - Firebase Auth UID
 *   email      {string}   - user email
 *   ownerName  {string}   - user's display name (used on the order + admin email)
 *   onAgreed   {func}     - optional, called after agreement is confirmed/signed
 *   variant    {string}   - MUI Button variant (default: "contained")
 *   size       {string}   - MUI Button size (default: "medium")
 *   sx         {object}   - extra MUI sx overrides
 *   disabled   {bool}     - passthrough disabled state
 */
const FindMeATenantButton = ({
  uid,
  email,
  ownerName,
  onAgreed,
  variant = "contained",
  size = "medium",
  sx = {},
  disabled = false,
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [flowOpen, setFlowOpen] = useState(false);

  const handleClick = () => {
    setDialogOpen(true);
  };

  const handleAgreed = () => {
    setDialogOpen(false);
    onAgreed?.();
    setFlowOpen(true);
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <Button
        variant={variant}
        size={size}
        startIcon={<PersonSearchIcon />}
        onClick={handleClick}
        disabled={disabled}
        sx={{
          textTransform: "none",
          borderRadius: 2,
          fontWeight: 600,
          ...sx,
        }}
      >
        Find Me A Tenant
      </Button>

      <BlanketAgreementDialog
        open={dialogOpen}
        onClose={handleClose}
        onAgreed={handleAgreed}
        uid={uid}
        email={email}
        fullName={ownerName}
      />

      <FindMeATenantFlow
        open={flowOpen}
        onClose={() => setFlowOpen(false)}
        uid={uid}
        email={email}
        ownerName={ownerName}
      />
    </>
  );
};

export default FindMeATenantButton;